module.exports = __webpack_public_path__ + "img/kenyan-dawa.54b32ce3.jpg";